import React, { useState, useEffect, Fragment } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";



//
import { Md3DRotation, MdGrid3X3, MdHelp, MdLanguage, MdPayment } from "react-icons/md";
import { IoLanguageOutline } from "react-icons/io5";
import { CgProfile } from "react-icons/cg";
import { RiLockUnlockFill } from "react-icons/ri";



//
import { IoIosAddCircleOutline, IoIosCheckboxOutline, IoIosCalendar, IoIosHome, IoIosAddCircle } from "react-icons/io";

import { AiOutlineCamera } from "react-icons/ai";
import { HiOutlineTranslate } from "react-icons/hi";


///
import Modal from "../../Layout/theme/modal/index";
import Language from '../../../language/index';
import { ChangeLanguageItem } from '../../../redux/featuer/user/userSlice'
import Dropdown from "../../dropdown";
import { Logout } from "../../../redux/featuer/user/userSlice";
import toast from "react-hot-toast";


function Header() {

    const { token, user, language } = useSelector((item) => item.user)




    const [url, setUrl] = useState("")
    const [showCameraModal, setShowCameraMoadal] = useState(false)
    const [showlangModal, setShowlangModal] = useState(false)
    const [showdropdown, setShowDropdown] = useState(false)
    const [dataFinancial, setDataFinancial] = useState()

    var { t } = useTranslation();
    var dispach = useDispatch();

    useEffect(() => {
        if (user.length === 0) {
            window.location.href = '/auth';
        }
        getStatusData()
        window.addEventListener('goftino_ready', function () {
            window.Goftino.setUser({
                name: user.name,
                phone: user.phone,
                forceUpdate: true
            });
        });
    }, [user])


    async function getStatusData() {
        await fetch(`${process.env.REACT_APP_SERVER}/api/billing/status`, {
            method: "GET",
            headers: {
                Authorization: "ArNew " + token,
            },
        }).then((res) => {
            res
                .json()
                .then((result) => {
                    if (!result.data) {
                        dispach(Logout());
                        toast.error("شما دسترسی ندارید");
                        window.location.href = '/auth';
                    }
                    if (result.status === "success") {
                        setDataFinancial(result.data)
                    } else {
                        toast.error(result.msg);
                        dispach(Logout());
                        window.location.href = 'login';
                    }
                })
                .catch((error) => {
                    // window.location.href = '/auth';
                    console.log(error);
                });
        });
    }




    // function toggleModal() {
    //     document.getElementById('profile').classList.toggle('hidden')
    // }

    const [scrollActive, setScrollActive] = useState(false);
    useEffect(() => {
        window.addEventListener("scroll", () => {
            setScrollActive(window.scrollY > 20);
        });
    }, []);

    const formatPrice = (value) => {
        return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    return (
        <>

            <header
                className={
                    "fixed top-0 w-full  z-30 bg-white transition-all  " +
                    (scrollActive && " shadow-md")
                }
                dir={language === 'en' ? "ltr" : 'rtl'}
            >
                <nav className="grid grid-cols-12 px-6 py-3 mx-auto text-base font-normal text-gray-600 max-w-screen-2xl sm:px-8 lg:px-16 sm:py-4">

                    <div className={
                        "col-start-1 col-end-2  flex items-center"
                    }>
                        <Link to={"/"}>
                            <img src={process.env.REACT_APP_ADDRESS + "/img/logo bg white.png"} className="h-10 cursor-pointer !min-h-0" />
                        </Link>
                    </div>

                    <ul className="items-center hidden col-start-2 col-end-10 lg:flex text-black-500 ">
                        <Link to={"/"}>
                            <p className="relative inline-block px-4 py-2 mx-2 cursor-pointer animation-hover text-black-500 " >
                                خانه
                            </p>
                        </Link>

                        {/* <Link to={'/showOrder'}>
                            <p className="relative inline-block px-4 py-2 mx-2 cursor-pointer animation-hover text-black-500 " >
                                {t("create_augmented_reality")}
                            </p>
                        </Link> */}

                        <Link to={'/projects'}>
                            <p className="relative inline-block px-4 py-2 mx-2 cursor-pointer animation-hover text-black-500 " >
                                پروژه ها
                            </p>
                        </Link>

                        {/* <Link to={'/order'}>
                            <p className="relative inline-block px-4 py-2 mx-2 cursor-pointer animation-hover text-black-500 " >
                                {t("orders")}
                            </p>
                        </Link> */}

                        <Link target="_blank" to={'https://arlive.me/category/%d8%a2%d9%85%d9%88%d8%b2%d8%b4/'}>
                            <p className="relative inline-block px-4 py-2 mx-2 cursor-pointer animation-hover text-black-500 " >
                                راهنما
                            </p>
                        </Link>

                        <Link target="_blank" to={'https://arlive.me/editor/'}>
                            <p className="relative inline-block px-4 py-2 mx-2 cursor-pointer animation-hover text-black-500 " >
                                ویرایشگر سه بعدی
                            </p>
                        </Link>

                        {/* <Link to={'/billing/data'}>
                            <p className="relative inline-block px-4 py-2 mx-2 cursor-pointer animation-hover text-black-500 " >
                                اشتراک
                            </p>
                        </Link> */}

                        {/* <p className="relative inline-block px-4 py-2 mx-2 cursor-pointer animation-hover text-black-500 " onClick={() => setShowCameraMoadal(true)} >
                            {t("camera")}
                        </p> */}

                    </ul>

                    <div className="flex items-center justify-end col-start-10 col-end-13 ">
                        {user && user.payments && user.payments.type == "DAILY" && (
                            <Dropdown
                                className="flex items-center gap-2 py-2 mx-2 cursor-pointer "
                                title={'اعتبار'}
                                iconHTML={<MdPayment />}
                            >

                                <ul className="my-2 space-y-3 text-sm font-normal w-[250px]" onClick={() => setShowDropdown(!showdropdown)}>
                                    <li>
                                        <div className=" p-2 px-2 text-sm text-gray-600 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-white" role="menuitem">
                                            <div className="inline-flex items-center justify-start text-center w-full gap-2">
                                                از اعتبار تنها برای ساخت واقعیت افزوده و سرویس‌های زیرساخت می‌توانید استفاده نمایید
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="block p-2 px-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-white" role="menuitem">
                                            <div className="inline-flex items-center justify-center text-center w-full gap-2">
                                                <p className="font-normal">اعتبار کل</p>
                                            </div>
                                            <div className="inline-flex items-center justify-center text-center w-full gap-3">
                                                <p className="font-bold text-gray-500 text-[1.1rem]">{formatPrice(user.payments.balance.toString())} تومان</p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="block p-2 px-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-white" role="menuitem">
                                            <div className="inline-flex items-center justify-center text-center w-full gap-2">
                                                <p className="font-normal">هزینه حدودی روزانه: </p>
                                                <p className="font-normal"> {dataFinancial ? formatPrice((dataFinancial.sum).toString()) : '-'} تومان </p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <Link to={'/pay/increase'}>
                                            <div className="block cursor-pointer p-2 px-2 text-sm rounded-lg bg-blue-800 hover:bg-blue-700 dark:bg-blue-800 " role="menuitem">
                                                <div className="inline-flex items-center justify-center text-center w-full gap-2">
                                                    <div className="w-full font-bold text-[1rem] text-white">
                                                        افزایش اعتبار
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    </li>
                                </ul>
                            </Dropdown>
                        )}

                        {/* <Dropdown
    className="items-center hidden gap-2 py-2 mx-2 cursor-pointer lg:flex"
    title={t('change_language')}
    // width={"w-[150px]"}
    iconHTML={<MdLanguage />}
>
    <ul className="my-2 space-y-3 text-sm font-normal " onClick={() => setShowDropdown(!showdropdown)}>
        <li
            className="p-0"
            onClick={() => {
                Language.changeLanguage("fa")
                dispach(ChangeLanguageItem("fa"))
            }}>
            <div className="block p-3 px-4 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-white" role="menuitem">
                <div className="inline-flex items-center justify-start w-full gap-2">
                    <IoLanguageOutline size={25} color={"black"} />
                    <span>فارسی</span>
                </div>
            </div>
        </li>
        <li
            className="p-0"
            onClick={() => {
                Language.changeLanguage("en")
                dispach(ChangeLanguageItem("en"))
            }
            }>
            <div className="block p-3 px-4 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-white" role="menuitem">
                <div className="inline-flex items-center justify-start w-full gap-2">
                    <IoLanguageOutline size={25} color={"black"} />
                    <span>English</span>
                </div>
            </div>
        </li>
        <li
            className="p-0 cursor-pointer"
            onClick={() => {
                Language.changeLanguage("ar")
                dispach(ChangeLanguageItem("ar"))
            }}>
            <div className="block p-3 px-4 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-white" role="menuitem">
                <div className="inline-flex items-center justify-start w-full gap-2">
                    <IoLanguageOutline size={25} color={"black"} />
                    <span>عربي</span>
                </div>
            </div>
        </li>
    </ul>
</Dropdown> */}

                        <Dropdown
                            className="flex items-center gap-2 py-2 mx-2 cursor-pointer "
                            title={t("profile")}
                            width={"w-60 lg:w-fit"}
                            iconHTML={<CgProfile />}
                        >
                            <ul className="my-2 space-y-3 text-sm font-normal w- " onClick={() => setShowDropdown(!showdropdown)}>

                                <li>
                                    <div className="block p-2 px-4 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-white" role="menuitem">
                                        <div className="inline-flex items-center justify-start w-full gap-2">
                                            {/* <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1} stroke="currentColor" className="w-7 h-7">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg> */}

                                            <p className="text-right">{user.name}</p>
                                        </div>
                                    </div>
                                </li>
                                <hr className="h-px my-8 bg-gray-200 border-0 dark:bg-gray-700" />
                                <li >
                                    <Link to={`/user/profile`}>
                                        <div className="block p-2 px-4 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-white" role="menuitem">
                                            <div className="inline-flex items-center justify-start w-full gap-2">
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1} stroke="currentColor" className="w-7 h-7">
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                                                </svg>
                                                {t("edit_profile")}
                                            </div>
                                        </div>
                                    </Link>
                                </li>

                                <li>
                                    <div className="block p-2 px-5 text-sm text-gray-700 cursor-pointer hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-white" role="menuitem">
                                        <a onClick={() => {
                                            window.location.href = `/change-password/${user._id}`;
                                        }} >
                                            <div className="inline-flex items-center justify-start w-full gap-2">
                                                <RiLockUnlockFill size={"22px"} />

                                                <p className="">{t("change_password")}</p>
                                            </div>
                                        </a>
                                    </div>
                                </li>

                                <li>
                                    <div className="block p-2 px-4 text-sm text-gray-700 cursor-pointer hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-white" role="menuitem">
                                        <a onClick={() => {
                                            dispach(Logout());
                                            window.location.href = "/auth";
                                        }} >
                                            <div className="inline-flex items-center justify-start w-full gap-2">
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1} stroke="currentColor" className="w-7 h-7">
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75" />
                                                </svg>
                                                {t("sign_out")}
                                            </div>
                                        </a>
                                    </div>
                                </li>


                            </ul>
                        </Dropdown>
                    </div>


                </nav>

            </header >

            <Modal isVisible={showCameraModal} onClose={() => setShowCameraMoadal(false)} >
                <div className="px-6 py-6 lg:px-8">
                    <h3 className="flex justify-center mt-5 mb-4 text-xl font-medium text-gray-900 dark:text-white">{t("fill_the_box_below")}</h3>

                    <div dir="rtl">{t("fill_the_box_below")}

                        <label className="flex justify-start mb-2 text-sm font-medium text-gray-900 ">{t("augmented_reality_code")}</label>
                        <input onChange={(e) => setUrl(e.target.value)} type="text" name="email" id="email" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white" placeholder={t("link")} required="" />
                    </div>
                    <Link to={`view/${user.username}/${url}`}>
                        <button className="w-full mt-5 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                            {t("registration")}
                        </button>
                    </Link>
                </div>
            </Modal>
            <Modal isVisible={showlangModal} onClose={() => setShowlangModal(false)} >
                <ul className="my-2 space-y-3 text-sm font-normal " onClick={() => setShowDropdown(!showdropdown)}>

                    <li
                        className="p-0"

                        onClick={() => {
                            Language.changeLanguage("fa")
                            dispach(ChangeLanguageItem("fa"))
                        }}>
                        <div className="block p-3 px-4 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-white" role="menuitem">
                            <div className="inline-flex items-center justify-start w-full gap-2">
                                <IoLanguageOutline size={25} color={"black"} />
                                <span>فارسی</span>
                            </div>
                        </div>
                    </li>
                    {/* <li
                        className="p-0"
                        onClick={() => {
                            Language.changeLanguage("en")
                            dispach(ChangeLanguageItem("en"))
                        }

                        }>
                        <div className="block p-3 px-4 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-white" role="menuitem">
                            <div className="inline-flex items-center justify-start w-full gap-2">
                                <IoLanguageOutline size={25} color={"black"} />
                                <span>English</span>
                            </div>
                        </div>
                    </li>
                    <li
                        className="p-0 cursor-pointer"
                        onClick={() => {
                            Language.changeLanguage("ar")
                            dispach(ChangeLanguageItem("ar"))
                        }}>
                        <div className="block p-3 px-4 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-white" role="menuitem">
                            <div className="inline-flex items-center justify-start w-full gap-2">
                                <IoLanguageOutline size={25} color={"black"} />
                                <span>عربي</span>
                            </div>
                        </div>
                    </li> */}


                </ul>
            </Modal>
            {/* Mobile Navigation */}

            < nav className="fixed bottom-0 left-0 right-0 z-20 w-full lg:hidden shadow-t " >
                <div className="px-4 py-2 bg-white sm:px-8">
                    {/* flex flex-3 items-center justify-between w-full */}
                    <div className="grid grid-cols-4 text-black-500">
                        {/* <Link to={'/showOrder'}>
                            <p className="flex flex-col items-center py-2 text-xs transition-all border-t-2 border-transparent " >
                                <IoIosAddCircleOutline className="w-6 h-6" />
                                {t("create_augmented_reality")}
                            </p>
                        </Link> */}
                        <Link to={'/'}>
                            <p className="flex flex-col items-center py-2 text-xs transition-all border-t-2 border-transparent " >
                                <IoIosHome className="w-6 h-6" />
                                خانه
                            </p>
                        </Link>
                        <Link to={'/projects'}>
                            <p className="flex flex-col items-center py-2 text-xs transition-all border-t-2 border-transparent " >
                                <IoIosAddCircle className="w-6 h-6" />
                                پروژه ها
                            </p>
                        </Link>

                        {/* <Link to={'/order'}>
                            <p className="flex flex-col items-center py-2 text-xs transition-all border-t-2 border-transparent " >
                                <IoIosCalendar className="w-6 h-6" />
                                {t("orders")}
                            </p>
                        </Link> */}


                        <Link target="_blank" to={'https://arlive.me/category/%d8%a2%d9%85%d9%88%d8%b2%d8%b4/'}>
                            <p className="flex flex-col items-center py-2 text-xs transition-all border-t-2 border-transparent " >
                                <MdHelp className="w-6 h-6" />
                                راهنما
                            </p>
                        </Link>

                        <Link target="_blank" to={'https://arlive.me/editor/'}>
                            <p className="flex flex-col items-center py-2 text-xs transition-all border-t-2 border-transparent " >
                                <Md3DRotation className="w-6 h-6" />
                                ویرایشگر سه بعدی
                            </p>
                        </Link>

                        {/* <Link to={'/billing/data'}>
                            <p className="flex flex-col items-center py-2 text-xs transition-all border-t-2 border-transparent " >

                                <MdPayment className="w-6 h-6" />
                                اشتراک
                            </p>
                        </Link> */}


                        {/* <p className="flex flex-col items-center py-2 text-xs transition-all border-t-2 border-transparent " onClick={() => setShowCameraMoadal(true)} >
                            <AiOutlineCamera className="w-6 h-6" />
                            {t("camera")}
                        </p> */}


                        {/* <p className="flex flex-col items-center py-2 text-xs transition-all border-t-2 border-transparent " onClick={() => setShowlangModal(!showdropdown)} >
                            <MdLanguage className="w-6 h-6" />
                            {t('change_language')}
                        </p> */}
                    </div>
                </div>
            </nav >
            {/* End Mobile Navigation */}

        </>
    )
}

export default Header
